import { withLoading } from "hocs/withLoading";
import { lazy } from "react";

export { default as SupplierInfors } from "./SupplierInfors";
export const RatingInfors = withLoading(lazy(() => import("./RatingInfors")));
